/**
 * AUTOGENERATED, DO NOT EDIT!
 *
 * https://gitlab.com/digital-pharma-tools/open-api-codegen
 *
 */
export enum MenuLayoutEnum {
    DROPDOWN = 'DROPDOWN',
    BAR = 'BAR',
}